module.exports = __webpack_public_path__ + "fonts/009b4353469af2e76d8ae058f8796f76.txt";